import ArrowLeft from './ArrowLeft'

export default ArrowLeft
// eslint-disable-next-line import/export
export * from './ArrowLeft'
